import { TypeExpertise } from './type-expertise';
import { User } from './user';
  import { Collaborateur } from './collaborateur';
import { Contact } from './contact';
import { Prestation } from './prestation';
import * as moment from 'moment';

export class Expertise {

  public loading: boolean;
  public uidUpdate: number = 1;


	public id: number;
	public number: string;
	public name: string;
	public comment: string;
	public status: number;
	public open_fee: number;
	public acompte: number;
	public t_expert_hrs: number;
	public t_collaborateur_hrs: number;
	public t_report_page: number;
	public t_deplacement_hrs: number;
	public t_deplacement_km: number;
	public pct_base_satellite: number;
	public pct_base_collaborateur: number;
  public workflow: any;
  public street: string;
  public zip_code: string;
  public locality: string;
  public tarifs: any;
  public invoicesOut: any;
  public invoicesIn: any;
  public consignments: any;
  public total_invoiced: any;

	private _contact: Contact;
  private _address: Contact;
  private _assurance: Contact;

	private _type: TypeExpertise;

	private _date_in: Date;
  private _date_visite: Date;
  private _date_cloture: Date;
	private _baseUser: User;
	private _satelliteUser: User;
  private _prestations: Prestation[] = [];
  private _collaborateurs: Collaborateur[] = [];


  	constructor(
  	) {}

  	set type(t: any) {
  		if (typeof t === 'number') {
  			this._type = Object.assign((new TypeExpertise),{id: t});
  		} else if (t instanceof TypeExpertise ) {
  			this._type = t;
  		} else {
  			this._type = Object.assign((new TypeExpertise),t);
  		}
  	}

  	get type(): any {
  		return this._type;
  	}

  	set date_in(t: any) {

  		if (typeof t === 'string') {
  			this._date_in = moment(t).toDate();
  		} else if (t instanceof Date ) {
  			this._date_in = t;
  		}
  	}

  	get date_in(): any {
  		return this._date_in;
  	}
  	get date_inStr(): any {
  		return moment(this._date_in).format('YYYY-MM-DD');
  	}


    set date_visite(t: any) {

      if (typeof t === 'string') {
        this._date_visite = moment(t).toDate();
      } else if (t instanceof Date ) {
        this._date_visite = t;
      } else {
        this._date_visite = null;
      }
    }

    get date_visite(): any {
      return this._date_visite;
    }
    get date_visiteStr(): any {
      return this._date_visite ? moment(this._date_visite).format('YYYY-MM-DD') : null;
    }
    set date_cloture(t: any) {

      if (typeof t === 'string') {
        this._date_cloture = moment(t).toDate();
      } else if (t instanceof Date ) {
        this._date_cloture = t;
      } else {
        this._date_cloture = null;
      }
    }

    get date_cloture(): any {
      return this._date_cloture;
    }
    get date_clotureStr(): any {
      return this._date_cloture ? moment(this._date_cloture).format('YYYY-MM-DD') : null;
    }

  	public toRequest(): any {

  		let a = Object.assign({},{
  			id: this.id|| null,
        name: this.name|| null,
        number: this.number || null,
  			date_in: this.date_inStr|| null,
        date_visite: this.date_visiteStr|| null,
        date_cloture: this.date_clotureStr|| null,
  			type_id: this.type.id || null,
        comment: this.comment|| null,
        street: this.street|| null,
        zip_code: this.zip_code|| null,
        locality: this.locality|| null,
        contact_id: this.contact.id || null,
        contact_data: this.contact || null,
        address_id: this.address.id || null,
        address_data: this.address || null,
        assurance_id: (this.assurance && this.assurance.id) || null,
        assurance_data: this.assurance || null,

        base_user_id: this.baseUser.id || null,
        satellite_user_id: this.satelliteUser.id || null,
        open_fee:this.open_fee || null,
	      acompte: this.acompte || null,
        t_expert_hrs:this.t_expert_hrs || null,
        t_collaborateur_hrs:this.t_collaborateur_hrs || null,
        t_report_page:this.t_report_page || null,
        t_deplacement_hrs:this.t_deplacement_hrs || null,
        t_deplacement_km:this.t_deplacement_km || null,
        tarifs:this.tarifs || null,
        pct_base_satellite:this.pct_base_satellite || null,
        pct_base_collaborateur:this.pct_base_collaborateur || null,
        collaborateur_data: this.collaborateurs ? this.collaborateurs.map(c => c.toRequest()) : null,
  		});
  		return a;
  	}

    get contact(): any {
      return this._contact;
    }
    set contact(t: any) {
      if (typeof t === 'number') {
        this._contact = Object.assign((new Contact),{id: t});
      } else if (typeof t === 'string' ) {
        this._contact = Object.assign((new Contact),{name: t});
      } else if (t instanceof Contact ) {
        this._contact = t;
      } else {
        this._contact = Object.assign((new Contact),t);
      }
    }

    get assurance(): any {
      return this._assurance;
    }
    set assurance(t: any) {
      if (typeof t === 'number') {
        this._assurance = Object.assign((new Contact),{id: t});
      } else if (typeof t === 'string' ) {
        this._assurance = Object.assign((new Contact),{name: t});
      } else if (t instanceof Contact ) {
        this._assurance = t;
      } else {
        this._assurance = Object.assign((new Contact),t);
      }
    }
    get address(): any {
      return this._address;
    }
    set address(t: any) {
      if (typeof t === 'number') {
        this._address = Object.assign((new Contact),{id: t});
      } else if (typeof t === 'string' ) {
        this._address = Object.assign((new Contact),{name: t});
      } else if (t instanceof Contact ) {
        this._address = t;
      } else {
        this._address = Object.assign((new Contact),t);
      }
    }

    get baseUser(): any {
      return this._baseUser;
    }
    set baseUser(t: any) {

      if (typeof t === 'number') {
        this._baseUser = Object.assign((new User),{id: t});
      } else if (t instanceof User ) {
        this._baseUser = t;
      } else {
        this._baseUser = Object.assign((new User),t);
      }
    }
    get satelliteUser(): any {
      return this._satelliteUser;
    }
    set satelliteUser(t: any) {

      if (typeof t === 'number') {
        this._satelliteUser = Object.assign((new User),{id: t});
      } else if (t instanceof User ) {
        this._satelliteUser = t;
      } else {
        this._satelliteUser = Object.assign((new User),t);
      }
    }
    get prestations(): any[] {
      return this._prestations;
    }
    set prestations(t: any[]) {
      this._prestations = t.map(p => {
        if (typeof p === 'number') {
          return Object.assign((new Prestation),{id: p});
        } else if (p instanceof Prestation ) {
          return p;
        } else {
          return Object.assign((new Prestation),p);
        }
      });
    }
    get collaborateurs(): any[] {
      return this._collaborateurs;
    }
    set collaborateurs(t: any[]) {
      if (t) {
        this._collaborateurs = t.map(p => {
          if (typeof p === 'number') {
            return Object.assign((new Collaborateur),{id: p});
          } else if (p instanceof Collaborateur ) {
            return p;
          } else {
            return Object.assign((new Collaborateur),p);
          }
        });

      }
    }

    get publicIdentity(): string {
      return this.number + " " + this.name;
    }

    get collaborateurs_str(): string {
      return this._collaborateurs.map(c => c.user.publicIdentity).join(', ');
    }
}
